import { isBrowser } from 'utils/environment';
import { getElementHeight } from 'utils/getElementHeight';

export const scrollToElement = ({
  id,
  scrollYPos,
}: {
  id: string;
  scrollYPos: number;
}) => {
  if (isBrowser) {
    const headerHeight = getElementHeight('header');
    const contentsHeight = getElementHeight('blog-contents');
    const breathingRoomHeight = 20;
    const offsetTop = contentsHeight + breathingRoomHeight;

    const element = document.getElementById(id);
    if (!element) return;
    const currentScrollToPosition =
      element.getBoundingClientRect().top + window.pageYOffset - offsetTop;

    // The header will transition to fixed when scrolling down
    const isScrollingDown = currentScrollToPosition > scrollYPos;

    const scrollToPosition = isScrollingDown
      ? currentScrollToPosition
      : currentScrollToPosition - headerHeight;

    setTimeout(() => {
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth',
      });
    }, 10);
  }
};
